export default "__VITE_ASSET__ClppsJqF__"